import { useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function AdminMobileGuard({ children }: Props) {
  const location = useLocation();

  if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/sa') || location.pathname.startsWith('/app')) {
    return null;
  }

  return <>{children}</>;
}